// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header */
/* Color tokens now come from Technum.css (:root) as --technum-* */
.technumopus-header {
  --header-height: 70px; /* Initial header height */
  --header-scrolled-height: 50px; /* Scrolled header height */
  --logo-width: 250px; /* Initial logo width */
  --logo-scrolled-width: 200px; /* Scrolled logo width */

  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06);
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  position: sticky;
  top: 0;
  z-index: 1000;
  height: var(--header-height);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: height, padding;
}

.technumopus-header--scrolled {
  height: var(--header-scrolled-height);
  padding: 4px 0;
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(20px) saturate(200%);
  -webkit-backdrop-filter: blur(20px) saturate(200%);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.technumopus-nav-container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 24px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.3s ease;
}

.technumopus-nav-content {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-around;
}

.technumopus-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  flex-shrink: 0;
}

.technumopus-logo-wrapper {
  width: var(--logo-width);
  height: auto;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: width;
}

.technumopus-header--scrolled .technumopus-logo-wrapper {
  width: var(--logo-scrolled-width);
}

.technumopus-logo-wrapper img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.technumopus-nav-menu {
  display: flex;
  list-style: none;
  gap: 32px;
  align-items: center;
  margin: 0;
  padding: 0;
  position: relative;
  min-width: 0;
}

.technumopus-nav-item {
  position: relative;
}

.technumopus-nav-item > a {
  text-decoration: none;
  color: var(--technum-navy);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-weight: 500;
  font-size: var(--body-regular);
  transition: all 0.3s ease;
  padding: 22px 0;
  display: block;
  position: relative;
}

.technumopus-nav-item > a.active {
  color: var(--technum-teal);
  font-weight: 600;
}

.technumopus-header--scrolled .technumopus-nav-item > a {
  padding: 16px 0;
}

.technumopus-nav-item > a:hover {
  color: var(--technum-teal);
}

/* Dropdown Container */
.technumopus-dropdown {
  position: absolute;
  top: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, var(--technum-white), rgba(240, 244, 248, 0.9));
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border: 1px solid var(--technum-gray-200);
  padding: 16px;
  min-width: 320px;
  opacity: 0;
  visibility: hidden;
  animation: fadeIn 0.2s ease forwards;
  z-index: 1000;
}

.technumopus-header--scrolled .technumopus-dropdown {
  top: calc(100% + 5px);
}

@keyframes fadeIn {
  to {
    opacity: 1;
    visibility: visible;
  }
}

/* Dropdown Arrow */
.technumopus-dropdown::before {
  content: '';
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 12px;
  height: 12px;
  background: var(--technum-white);
  border: 1px solid var(--technum-gray-200);
  border-bottom: none;
  border-right: none;
}

/* Extend hover area */
.technumopus-dropdown::after {
  content: '';
  position: absolute;
  top: -20px;
  left: 0;
  right: 0;
  height: 20px;
}

/* Dropdown Links */
.technumopus-dropdown a {
  display: block;
  padding: 10px 16px;
  color: var(--technum-steel);
  text-decoration: none;
  font-size: var(--body-regular);
  border-radius: 6px;
  transition: all 0.3s ease;
  position: relative;
  font-weight: 450;
}

.technumopus-dropdown a:hover {
  color: var(--technum-teal);
  background: rgba(0, 168, 150, 0.1);
  border-left: 4px solid var(--technum-teal);
  padding-left: 12px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.05);
}

/* Industries Dropdown */
.technumopus-dropdown-industries {
  min-width: 340px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.technumopus-dropdown-group {
  flex: 1 1;
  min-width: 100%;
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.technumopus-dropdown-group h5 {
  font-size: var(--caption);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--technum-navy);
  opacity: 0.7;
  margin: 0 0 12px 0;
}

.technumopus-featured {
  background: rgba(0, 168, 150, 0.08);
  color: var(--technum-teal);
  font-weight: 600;
}

.technumopus-featured:hover {
  background: rgba(0, 168, 150, 0.15);
  border-left: 4px solid var(--technum-teal);
  padding-left: 12px;
}

.technumopus-btn-primary {
  background: var(--technum-teal);
  color: var(--technum-white);
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-weight: 500;
  font-size: var(--btn-size);
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
  display: inline-block;
}

.technumopus-header--scrolled .technumopus-btn-primary {
  padding: 8px 20px;
  font-size: 14px;
}

/* Tablets (up to 1024px) */
@media (max-width: 1024px) {
  .technumopus-header {
    --header-height: 56px;
    --header-scrolled-height: 44px;
    --logo-width: 170px;
    --logo-scrolled-width: 140px;
  }

  .technumopus-nav-container {
    padding: 0 var(--container-padding);
  }

  .technumopus-nav-menu {
    gap: 20px;
    min-width: 0;
    flex-wrap: wrap;
    justify-content: center;
  }

  .technumopus-nav-item > a {
    font-size: var(--body-small);
    padding: 16px 0;
  }

  .technumopus-dropdown {
    min-width: 260px;
    padding: 10px;
    top: calc(100% + 6px);
  }

  .technumopus-dropdown-industries {
    min-width: 280px;
  }

  .technumopus-dropdown a {
    font-size: var(--body-small);
    padding: 7px 12px;
  }

  .technumopus-dropdown-group h5 {
    font-size: var(--caption);
    margin-bottom: 10px;
  }

  .technumopus-btn-primary {
    padding: 8px 18px;
    font-size: var(--btn-size);
  }

  .technumopus-header--scrolled .technumopus-btn-primary {
    padding: 6px 16px;
    font-size: var(--caption);
  }
}

/* Mobile Landscape (up to 768px) */
@media (max-width: 768px) {
  .technumopus-header {
    --header-height: 48px;
    --header-scrolled-height: 48px;
    --logo-width: 140px;
    --logo-scrolled-width: 140px;
  }

  .technumopus-nav-container {
    padding: 0 16px;
    height: 48px;
  }

  .technumopus-nav-content {
    flex-direction: column;
    align-items: center;
  }

  .technumopus-nav-menu {
    display: none;
  }

  .technumopus-logo {
    margin-bottom: 0;
  }

  .technumopus-btn-primary {
    padding: 8px 16px;
    font-size: var(--btn-size);
    width: 100%;
    text-align: center;
    margin: 10px 0 0;
  }

  .technumopus-header--scrolled .technumopus-btn-primary {
    padding: 6px 14px;
    font-size: var(--caption);
  }

  .technumopus-dropdown {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: calc(100vw - 40px);
    max-width: 300px;
    padding: 12px;
  }

  .technumopus-dropdown::before {
    display: none;
  }

  .technumopus-dropdown-industries {
    min-width: calc(100vw - 40px);
    max-width: 300px;
  }

  .technumopus-dropdown a {
    font-size: var(--body-small);
    padding: 6px 10px;
  }

  .technumopus-dropdown-group h5 {
    font-size: var(--caption);
    margin-bottom: 8px;
  }
}

/* Mobile Portrait (up to 480px) */
@media (max-width: 480px) {
  .technumopus-header {
    --logo-width: 140px;
    --logo-scrolled-width: 140px;
  }

  .technumopus-nav-container {
    padding: 0 12px;
  }

  .technumopus-logo {
    margin-bottom: 0;
  }

  .technumopus-btn-primary {
    padding: 7px 14px;
    font-size: var(--btn-size);
    margin-top: 8px;
  }

  .technumopus-header--scrolled .technumopus-btn-primary {
    padding: 5px 12px;
    font-size: var(--caption);
  }

  .technumopus-dropdown {
    min-width: calc(100vw - 32px);
    max-width: 280px;
    padding: 10px;
  }

  .technumopus-dropdown-industries {
    min-width: calc(100vw - 32px);
    max-width: 280px;
  }

  .technumopus-dropdown a {
    font-size: var(--body-small);
    padding: 5px 8px;
  }

  .technumopus-dropdown-group h5 {
    font-size: var(--caption);
    margin-bottom: 6px;
  }
}

/* Smaller Mobile Devices (up to 360px) */
@media (max-width: 360px) {
  .technumopus-header {
    --logo-width: 140px;
    --logo-scrolled-width: 140px;
  }

  .technumopus-nav-container {
    padding: 0 10px;
  }

  .technumopus-logo {
    margin-bottom: 0;
  }

  .technumopus-btn-primary {
    padding: 6px 12px;
    font-size: var(--btn-size);
    margin-top: 6px;
  }

  .technumopus-header--scrolled .technumopus-btn-primary {
    padding: 4px 10px;
    font-size: var(--caption);
  }

  .technumopus-dropdown {
    min-width: calc(100vw - 24px);
    max-width: 260px;
    padding: 8px;
  }

  .technumopus-dropdown-industries {
    min-width: calc(100vw - 24px);
    max-width: 260px;
  }

  .technumopus-dropdown a {
    font-size: var(--body-small);
    padding: 4px 6px;
  }

  .technumopus-dropdown-group h5 {
    font-size: var(--caption);
    margin-bottom: 5px;
  }
}

/* AWS Partner nav badge */
.technumopus-aws-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #FF9900, #e68a00);
  color: #fff !important;
  font-size: 12px;
  font-weight: 700;
  padding: 5px 14px;
  border-radius: 6px;
  letter-spacing: 0.02em;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(255, 153, 0, 0.25);
}

.technumopus-nav-aws > a {
  padding: 18px 0 !important;
}

.technumopus-nav-aws > a:hover .technumopus-aws-badge,
.technumopus-nav-aws > a.active .technumopus-aws-badge {
  background: linear-gradient(135deg, #FFB84D, #FF9900);
  box-shadow: 0 4px 16px rgba(255, 153, 0, 0.4);
  transform: translateY(-1px);
}

/* AWS badge in sidebar */
.technumopus-sidebar-aws a {
  border-bottom: none !important;
  padding-bottom: 0 !important;
}

.technumopus-sidebar-aws .technumopus-aws-badge {
  font-size: 13px;
  padding: 6px 16px;
}

/* AWS badge responsive */
@media (max-width: 1024px) {
  .technumopus-aws-badge {
    font-size: 11px;
    padding: 4px 12px;
  }
}

@media (max-width: 480px) {
  .technumopus-sidebar-aws .technumopus-aws-badge {
    font-size: 12px;
    padding: 5px 14px;
  }
}

@media (max-width: 360px) {
  .technumopus-sidebar-aws .technumopus-aws-badge {
    font-size: 11px;
    padding: 4px 12px;
  }
}

/* Hamburger Button */
.technumopus-hamburger {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
}

.technumopus-hamburger img {
  width: 28px;
  height: 28px;
}

/* Show hamburger <768px, hide nav menu initially */
@media (max-width: 768px) {
  .technumopus-hamburger {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    padding: 6px;
  }

  .technumopus-hamburger img {
    width: 24px;
    height: 24px;
  }

  .technumopus-nav-content {
    display: none !important;
  }

  .technumopus-nav-menu {
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .technumopus-nav-item > a {
    padding: 10px 0;
    font-size: var(--body-small);
  }

  .technumopus-btn-primary {
    width: 100%;
    margin-top: 12px;
  }

  /* Remove scroll transition on mobile for stable header */
  .technumopus-header--scrolled {
    padding: 0;
  }
}

/* Sidebar backdrop overlay */
.technumopus-sidebar-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1999;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.technumopus-sidebar-overlay--visible {
  opacity: 1;
  visibility: visible;
}

/* Sidebar base */
.technumopus-sidebar {
  position: fixed;
  top: 0;
  right: -100%;
  height: 100%;
  width: 300px;
  background: #001F3F;
  color: #fff;
  display: flex;
  flex-direction: column;
  /* Respect iOS notch (top), home indicator (bottom), right-edge inset. */
  padding: max(20px, env(safe-area-inset-top)) max(20px, env(safe-area-inset-right)) max(20px, env(safe-area-inset-bottom)) 20px;
  transition: right 0.3s ease-in-out;
  z-index: 2000;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);
  overflow-y: auto;
}

.technumopus-sidebar--open {
  right: 0;
}

/* Top row */
.technumopus-sidebar-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.technumopus-sidebar-top .technumopus-logo-wrapper {
  width: 160px;
  flex-shrink: 0;
}

.technumopus-sidebar-top .technumopus-logo-wrapper img {
  width: 100%;
  height: auto;
  object-fit: contain;
  filter: brightness(0) invert(1);
  opacity: 0.95;
}

.technumopus-sidebar-close {
  background: none;
  border: none;
  color: #fff;
  font-size: 22px;
  cursor: pointer;
  padding: 4px;
}

/* CTA at bottom of sidebar */
.technumopus-sidebar-cta {
  margin-top: auto;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.technumopus-sidebar-cta a {
  text-decoration: none;
}

/* Sidebar Menu */
.technumopus-sidebar-menu {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.technumopus-sidebar-menu a {
  color: #fff;
  text-decoration: none;
  font-size: var(--body-regular);
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  padding-bottom: 10px;
  transition: color 0.2s ease;
}

.technumopus-sidebar-menu a:hover {
  color: var(--technum-teal);
}

/* Sidebar dropdown toggles */
.technumopus-sidebar-dropdown-toggle {
  background: none;
  border: none;
  color: #fff;
  font-size: var(--body-regular);
  font-weight: 500;
  cursor: pointer;
  width: 100%;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  padding-bottom: 10px;
}

.technumopus-sidebar-submenu {
  list-style: none;
  margin: 10px 0 0 10px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.technumopus-sidebar-submenu a {
  font-size: var(--body-small);
  color: #bbb;
  border: none;
  padding: 0;
}

.technumopus-sidebar-submenu a:hover {
  color: var(--technum-teal);
}

/* Sidebar button styling */
.technumopus-sidebar .technumopus-btn-primary {
  background: #00A896;
  color: #fff;
  width: 100%;
  padding: 14px 20px;
  border-radius: 8px;
  font-size: var(--body-regular);
  font-weight: 600;
  text-align: center;
  border: none;
  cursor: pointer;
  transition: background 0.2s ease;
}

.technumopus-sidebar .technumopus-btn-primary:hover {
  background: #008573;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Header/Header.css"],"names":[],"mappings":"AAAA,WAAW;AACX,kEAAkE;AAClE;EACE,qBAAqB,EAAE,0BAA0B;EACjD,8BAA8B,EAAE,2BAA2B;EAC3D,mBAAmB,EAAE,uBAAuB;EAC5C,4BAA4B,EAAE,wBAAwB;;EAEtD,qCAAqC;EACrC,0CAA0C;EAC1C,kDAAkD;EAClD,yCAAyC;EACzC,iDAAiD;EACjD,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,4BAA4B;EAC5B,iDAAiD;EACjD,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,qCAAqC;EACrC,0CAA0C;EAC1C,kDAAkD;EAClD,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,+EAA+E;EAC/E,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,mFAAmF;EACnF,mBAAmB;EACnB,0CAA0C;EAC1C,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,yCAAyC;EACzC,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,0CAA0C;EAC1C,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,+EAA+E;EAC/E,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE;IACE,qBAAqB;IACrB,8BAA8B;IAC9B,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,SAAS;IACT,YAAY;IACZ,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;IAC5B,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,qBAAqB;IACrB,8BAA8B;IAC9B,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;IAC1B,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;AACF;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qDAAqD;EACrD,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,qDAAqD;EACrD,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,mDAAmD;AACnD;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA,yDAAyD;EACzD;IACE,UAAU;EACZ;AACF;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,wEAAwE;EACxE,8HAA8H;EAC9H,kCAAkC;EAClC,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,8CAA8C;EAC9C,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Header */\n/* Color tokens now come from Technum.css (:root) as --technum-* */\n.technumopus-header {\n  --header-height: 70px; /* Initial header height */\n  --header-scrolled-height: 50px; /* Scrolled header height */\n  --logo-width: 250px; /* Initial logo width */\n  --logo-scrolled-width: 200px; /* Scrolled logo width */\n\n  background: rgba(255, 255, 255, 0.75);\n  backdrop-filter: blur(16px) saturate(180%);\n  -webkit-backdrop-filter: blur(16px) saturate(180%);\n  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  height: var(--header-height);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: height, padding;\n}\n\n.technumopus-header--scrolled {\n  height: var(--header-scrolled-height);\n  padding: 4px 0;\n  background: rgba(255, 255, 255, 0.88);\n  backdrop-filter: blur(20px) saturate(200%);\n  -webkit-backdrop-filter: blur(20px) saturate(200%);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.technumopus-nav-container {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 0 24px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  transition: all 0.3s ease;\n}\n\n.technumopus-nav-content {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-around;\n}\n\n.technumopus-logo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  text-decoration: none;\n  flex-shrink: 0;\n}\n\n.technumopus-logo-wrapper {\n  width: var(--logo-width);\n  height: auto;\n  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: width;\n}\n\n.technumopus-header--scrolled .technumopus-logo-wrapper {\n  width: var(--logo-scrolled-width);\n}\n\n.technumopus-logo-wrapper img {\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n\n.technumopus-nav-menu {\n  display: flex;\n  list-style: none;\n  gap: 32px;\n  align-items: center;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  min-width: 0;\n}\n\n.technumopus-nav-item {\n  position: relative;\n}\n\n.technumopus-nav-item > a {\n  text-decoration: none;\n  color: var(--technum-navy);\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  font-weight: 500;\n  font-size: var(--body-regular);\n  transition: all 0.3s ease;\n  padding: 22px 0;\n  display: block;\n  position: relative;\n}\n\n.technumopus-nav-item > a.active {\n  color: var(--technum-teal);\n  font-weight: 600;\n}\n\n.technumopus-header--scrolled .technumopus-nav-item > a {\n  padding: 16px 0;\n}\n\n.technumopus-nav-item > a:hover {\n  color: var(--technum-teal);\n}\n\n/* Dropdown Container */\n.technumopus-dropdown {\n  position: absolute;\n  top: calc(100% + 10px);\n  left: 50%;\n  transform: translateX(-50%);\n  background: linear-gradient(135deg, var(--technum-white), rgba(240, 244, 248, 0.9));\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  border: 1px solid var(--technum-gray-200);\n  padding: 16px;\n  min-width: 320px;\n  opacity: 0;\n  visibility: hidden;\n  animation: fadeIn 0.2s ease forwards;\n  z-index: 1000;\n}\n\n.technumopus-header--scrolled .technumopus-dropdown {\n  top: calc(100% + 5px);\n}\n\n@keyframes fadeIn {\n  to {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n/* Dropdown Arrow */\n.technumopus-dropdown::before {\n  content: '';\n  position: absolute;\n  top: -6px;\n  left: 50%;\n  transform: translateX(-50%) rotate(45deg);\n  width: 12px;\n  height: 12px;\n  background: var(--technum-white);\n  border: 1px solid var(--technum-gray-200);\n  border-bottom: none;\n  border-right: none;\n}\n\n/* Extend hover area */\n.technumopus-dropdown::after {\n  content: '';\n  position: absolute;\n  top: -20px;\n  left: 0;\n  right: 0;\n  height: 20px;\n}\n\n/* Dropdown Links */\n.technumopus-dropdown a {\n  display: block;\n  padding: 10px 16px;\n  color: var(--technum-steel);\n  text-decoration: none;\n  font-size: var(--body-regular);\n  border-radius: 6px;\n  transition: all 0.3s ease;\n  position: relative;\n  font-weight: 450;\n}\n\n.technumopus-dropdown a:hover {\n  color: var(--technum-teal);\n  background: rgba(0, 168, 150, 0.1);\n  border-left: 4px solid var(--technum-teal);\n  padding-left: 12px;\n  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n/* Industries Dropdown */\n.technumopus-dropdown-industries {\n  min-width: 340px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.technumopus-dropdown-group {\n  flex: 1;\n  min-width: 100%;\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.technumopus-dropdown-group h5 {\n  font-size: var(--caption);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--technum-navy);\n  opacity: 0.7;\n  margin: 0 0 12px 0;\n}\n\n.technumopus-featured {\n  background: rgba(0, 168, 150, 0.08);\n  color: var(--technum-teal);\n  font-weight: 600;\n}\n\n.technumopus-featured:hover {\n  background: rgba(0, 168, 150, 0.15);\n  border-left: 4px solid var(--technum-teal);\n  padding-left: 12px;\n}\n\n.technumopus-btn-primary {\n  background: var(--technum-teal);\n  color: var(--technum-white);\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  font-weight: 500;\n  font-size: var(--btn-size);\n  text-decoration: none;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  display: inline-block;\n}\n\n.technumopus-header--scrolled .technumopus-btn-primary {\n  padding: 8px 20px;\n  font-size: 14px;\n}\n\n/* Tablets (up to 1024px) */\n@media (max-width: 1024px) {\n  .technumopus-header {\n    --header-height: 56px;\n    --header-scrolled-height: 44px;\n    --logo-width: 170px;\n    --logo-scrolled-width: 140px;\n  }\n\n  .technumopus-nav-container {\n    padding: 0 var(--container-padding);\n  }\n\n  .technumopus-nav-menu {\n    gap: 20px;\n    min-width: 0;\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .technumopus-nav-item > a {\n    font-size: var(--body-small);\n    padding: 16px 0;\n  }\n\n  .technumopus-dropdown {\n    min-width: 260px;\n    padding: 10px;\n    top: calc(100% + 6px);\n  }\n\n  .technumopus-dropdown-industries {\n    min-width: 280px;\n  }\n\n  .technumopus-dropdown a {\n    font-size: var(--body-small);\n    padding: 7px 12px;\n  }\n\n  .technumopus-dropdown-group h5 {\n    font-size: var(--caption);\n    margin-bottom: 10px;\n  }\n\n  .technumopus-btn-primary {\n    padding: 8px 18px;\n    font-size: var(--btn-size);\n  }\n\n  .technumopus-header--scrolled .technumopus-btn-primary {\n    padding: 6px 16px;\n    font-size: var(--caption);\n  }\n}\n\n/* Mobile Landscape (up to 768px) */\n@media (max-width: 768px) {\n  .technumopus-header {\n    --header-height: 48px;\n    --header-scrolled-height: 48px;\n    --logo-width: 140px;\n    --logo-scrolled-width: 140px;\n  }\n\n  .technumopus-nav-container {\n    padding: 0 16px;\n    height: 48px;\n  }\n\n  .technumopus-nav-content {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .technumopus-nav-menu {\n    display: none;\n  }\n\n  .technumopus-logo {\n    margin-bottom: 0;\n  }\n\n  .technumopus-btn-primary {\n    padding: 8px 16px;\n    font-size: var(--btn-size);\n    width: 100%;\n    text-align: center;\n    margin: 10px 0 0;\n  }\n\n  .technumopus-header--scrolled .technumopus-btn-primary {\n    padding: 6px 14px;\n    font-size: var(--caption);\n  }\n\n  .technumopus-dropdown {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    min-width: calc(100vw - 40px);\n    max-width: 300px;\n    padding: 12px;\n  }\n\n  .technumopus-dropdown::before {\n    display: none;\n  }\n\n  .technumopus-dropdown-industries {\n    min-width: calc(100vw - 40px);\n    max-width: 300px;\n  }\n\n  .technumopus-dropdown a {\n    font-size: var(--body-small);\n    padding: 6px 10px;\n  }\n\n  .technumopus-dropdown-group h5 {\n    font-size: var(--caption);\n    margin-bottom: 8px;\n  }\n}\n\n/* Mobile Portrait (up to 480px) */\n@media (max-width: 480px) {\n  .technumopus-header {\n    --logo-width: 140px;\n    --logo-scrolled-width: 140px;\n  }\n\n  .technumopus-nav-container {\n    padding: 0 12px;\n  }\n\n  .technumopus-logo {\n    margin-bottom: 0;\n  }\n\n  .technumopus-btn-primary {\n    padding: 7px 14px;\n    font-size: var(--btn-size);\n    margin-top: 8px;\n  }\n\n  .technumopus-header--scrolled .technumopus-btn-primary {\n    padding: 5px 12px;\n    font-size: var(--caption);\n  }\n\n  .technumopus-dropdown {\n    min-width: calc(100vw - 32px);\n    max-width: 280px;\n    padding: 10px;\n  }\n\n  .technumopus-dropdown-industries {\n    min-width: calc(100vw - 32px);\n    max-width: 280px;\n  }\n\n  .technumopus-dropdown a {\n    font-size: var(--body-small);\n    padding: 5px 8px;\n  }\n\n  .technumopus-dropdown-group h5 {\n    font-size: var(--caption);\n    margin-bottom: 6px;\n  }\n}\n\n/* Smaller Mobile Devices (up to 360px) */\n@media (max-width: 360px) {\n  .technumopus-header {\n    --logo-width: 140px;\n    --logo-scrolled-width: 140px;\n  }\n\n  .technumopus-nav-container {\n    padding: 0 10px;\n  }\n\n  .technumopus-logo {\n    margin-bottom: 0;\n  }\n\n  .technumopus-btn-primary {\n    padding: 6px 12px;\n    font-size: var(--btn-size);\n    margin-top: 6px;\n  }\n\n  .technumopus-header--scrolled .technumopus-btn-primary {\n    padding: 4px 10px;\n    font-size: var(--caption);\n  }\n\n  .technumopus-dropdown {\n    min-width: calc(100vw - 24px);\n    max-width: 260px;\n    padding: 8px;\n  }\n\n  .technumopus-dropdown-industries {\n    min-width: calc(100vw - 24px);\n    max-width: 260px;\n  }\n\n  .technumopus-dropdown a {\n    font-size: var(--body-small);\n    padding: 4px 6px;\n  }\n\n  .technumopus-dropdown-group h5 {\n    font-size: var(--caption);\n    margin-bottom: 5px;\n  }\n}\n\n/* AWS Partner nav badge */\n.technumopus-aws-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: linear-gradient(135deg, #FF9900, #e68a00);\n  color: #fff !important;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 5px 14px;\n  border-radius: 6px;\n  letter-spacing: 0.02em;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(255, 153, 0, 0.25);\n}\n\n.technumopus-nav-aws > a {\n  padding: 18px 0 !important;\n}\n\n.technumopus-nav-aws > a:hover .technumopus-aws-badge,\n.technumopus-nav-aws > a.active .technumopus-aws-badge {\n  background: linear-gradient(135deg, #FFB84D, #FF9900);\n  box-shadow: 0 4px 16px rgba(255, 153, 0, 0.4);\n  transform: translateY(-1px);\n}\n\n/* AWS badge in sidebar */\n.technumopus-sidebar-aws a {\n  border-bottom: none !important;\n  padding-bottom: 0 !important;\n}\n\n.technumopus-sidebar-aws .technumopus-aws-badge {\n  font-size: 13px;\n  padding: 6px 16px;\n}\n\n/* AWS badge responsive */\n@media (max-width: 1024px) {\n  .technumopus-aws-badge {\n    font-size: 11px;\n    padding: 4px 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .technumopus-sidebar-aws .technumopus-aws-badge {\n    font-size: 12px;\n    padding: 5px 14px;\n  }\n}\n\n@media (max-width: 360px) {\n  .technumopus-sidebar-aws .technumopus-aws-badge {\n    font-size: 11px;\n    padding: 4px 12px;\n  }\n}\n\n/* Hamburger Button */\n.technumopus-hamburger {\n  display: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n}\n\n.technumopus-hamburger img {\n  width: 28px;\n  height: 28px;\n}\n\n/* Show hamburger <768px, hide nav menu initially */\n@media (max-width: 768px) {\n  .technumopus-hamburger {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: auto;\n    padding: 6px;\n  }\n\n  .technumopus-hamburger img {\n    width: 24px;\n    height: 24px;\n  }\n\n  .technumopus-nav-content {\n    display: none !important;\n  }\n\n  .technumopus-nav-menu {\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n  }\n\n  .technumopus-nav-item > a {\n    padding: 10px 0;\n    font-size: var(--body-small);\n  }\n\n  .technumopus-btn-primary {\n    width: 100%;\n    margin-top: 12px;\n  }\n\n  /* Remove scroll transition on mobile for stable header */\n  .technumopus-header--scrolled {\n    padding: 0;\n  }\n}\n\n/* Sidebar backdrop overlay */\n.technumopus-sidebar-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 1999;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s ease, visibility 0.3s ease;\n}\n\n.technumopus-sidebar-overlay--visible {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Sidebar base */\n.technumopus-sidebar {\n  position: fixed;\n  top: 0;\n  right: -100%;\n  height: 100%;\n  width: 300px;\n  background: #001F3F;\n  color: #fff;\n  display: flex;\n  flex-direction: column;\n  /* Respect iOS notch (top), home indicator (bottom), right-edge inset. */\n  padding: max(20px, env(safe-area-inset-top)) max(20px, env(safe-area-inset-right)) max(20px, env(safe-area-inset-bottom)) 20px;\n  transition: right 0.3s ease-in-out;\n  z-index: 2000;\n  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);\n  overflow-y: auto;\n}\n\n.technumopus-sidebar--open {\n  right: 0;\n}\n\n/* Top row */\n.technumopus-sidebar-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.technumopus-sidebar-top .technumopus-logo-wrapper {\n  width: 160px;\n  flex-shrink: 0;\n}\n\n.technumopus-sidebar-top .technumopus-logo-wrapper img {\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n  filter: brightness(0) invert(1);\n  opacity: 0.95;\n}\n\n.technumopus-sidebar-close {\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: 22px;\n  cursor: pointer;\n  padding: 4px;\n}\n\n/* CTA at bottom of sidebar */\n.technumopus-sidebar-cta {\n  margin-top: auto;\n  padding-top: 24px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.technumopus-sidebar-cta a {\n  text-decoration: none;\n}\n\n/* Sidebar Menu */\n.technumopus-sidebar-menu {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.technumopus-sidebar-menu a {\n  color: #fff;\n  text-decoration: none;\n  font-size: var(--body-regular);\n  font-weight: 500;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid rgba(255,255,255,0.1);\n  padding-bottom: 10px;\n  transition: color 0.2s ease;\n}\n\n.technumopus-sidebar-menu a:hover {\n  color: var(--technum-teal);\n}\n\n/* Sidebar dropdown toggles */\n.technumopus-sidebar-dropdown-toggle {\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: var(--body-regular);\n  font-weight: 500;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0;\n  border-bottom: 1px solid rgba(255,255,255,0.1);\n  padding-bottom: 10px;\n}\n\n.technumopus-sidebar-submenu {\n  list-style: none;\n  margin: 10px 0 0 10px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.technumopus-sidebar-submenu a {\n  font-size: var(--body-small);\n  color: #bbb;\n  border: none;\n  padding: 0;\n}\n\n.technumopus-sidebar-submenu a:hover {\n  color: var(--technum-teal);\n}\n\n/* Sidebar button styling */\n.technumopus-sidebar .technumopus-btn-primary {\n  background: #00A896;\n  color: #fff;\n  width: 100%;\n  padding: 14px 20px;\n  border-radius: 8px;\n  font-size: var(--body-regular);\n  font-weight: 600;\n  text-align: center;\n  border: none;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.technumopus-sidebar .technumopus-btn-primary:hover {\n  background: #008573;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
